import { createContext } from "react";
export const DTConfigInGalleryContext = createContext(undefined);
